enum QBDQueueTypeEnum {
    READ = "READ",
    CREATE = "CREATE",
    UPDATE = "UPDATE",
    DELETE = "DELETE",
    PUSH = "PUSH",
}

export default QBDQueueTypeEnum;
